import script from "./UploadPbix.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPbix.vue?vue&type=script&setup=true&lang=js"

import "./UploadPbix.vue?vue&type=style&index=0&id=00f37acc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f37acc"]])

export default __exports__